import { Box, Tooltip } from '@material-ui/core';
import { LoanCriteria, MerchantStructure, OrderCriteria, Role, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { ChannelTypeIcons } from '@/components/modules/MerchantDetail/MerchantStructure/constants/ChannelTypeIcons';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { ICON_NAMES } from '@/config/config';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';
import { useUser } from '@/hooks/useUser';

export const channelAgentNameFieldColumn = ({ flex }: { flex?: number }) => {
  const { structure, userEntity } = useUser();

  const showMerchant = userEntity?.hasRole([
    Role.ROLE_SUPER_ADMIN,
    Role.ROLE_ADMIN,
    Role.ROLE_PARTNER,
    Role.ROLE_LENDER,
  ]);

  const getChannelIconName = (merchantStructure: MerchantStructure | undefined, channelId: string | null) => {
    const DEFAULT_ICON = ChannelTypeIcons.store;

    if (!merchantStructure || !channelId) return DEFAULT_ICON;

    const channel = MerchantStructureEntity.create({ merchantStructure, channelId }).getChannel();

    if (channel && channel.type in ChannelTypeIcons) {
      return ChannelTypeIcons[channel.type];
    }

    return DEFAULT_ICON;
  };

  return {
    flex: flex ?? 0.32,
    field: 'merchantName',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'SALES_CHANNEL'} />,
    renderCell: (rowData: { row: LoanCriteria | OrderCriteria | SinglePaymentCriteria }) => {
      const merchantStructure = structure
        ? structure
        : useGetMerchantStructureById(rowData.row.merchantId).merchantStructure;

      return (
        <Tooltip
          placement="top"
          title={
            <div style={{ maxWidth: '100%' }}>
              <div>{rowData.row.businessName}</div>
              <div>{rowData.row.channelDescription}</div>
            </div>
          }
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
              maxWidth: '100%',
            }}
          >
            <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'} className="overflow-text-ellipsis">
              {showMerchant && (
                <div style={{ maxWidth: '100%' }}>
                  <Box display={'flex'} flexDirection={'row'} gridGap={6} alignItems={'center'}>
                    <Icon size={18}>{ICON_NAMES.MERCHANT}</Icon>
                    <div className="overflow-text-ellipsis">{rowData.row.businessName}</div>
                  </Box>
                </div>
              )}
              <div style={{ maxWidth: '100%' }}>
                <Box display={'flex'} flexDirection={'row'} gridGap={6} alignItems={'center'}>
                  <Icon size={18}>{getChannelIconName(merchantStructure, rowData.row.channelId)}</Icon>
                  <div className="overflow-text-ellipsis">{rowData.row.channelDescription}</div>
                </Box>
              </div>
              {!showMerchant && (
                <div style={{ maxWidth: '100%' }}>
                  <Box display={'flex'} flexDirection={'row'} gridGap={6} alignItems={'center'}>
                    <Icon size={18}>account_circle</Icon>
                    <div className={'overflow-text-ellipsis'}>{rowData.row.agentName}</div>
                  </Box>
                </div>
              )}
            </Box>
          </div>
        </Tooltip>
      );
    },
  };
};
